import logoImage from "@/assets/logo-creafinancia-128.webp";
import { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";

interface AppLogoProps {
  className?: string;
  size?: "xs" | "sm" | "smc" | "md" | "lg" | "responsive" | "card";
  style?: CSSProperties;
  linkTo?: string | false;
  /** Set true for above-the-fold logos (hero, header) to prioritize loading */
  priority?: boolean;
}

const sizeClasses = {
  xs: "w-8 h-8",
  sm: "w-10 h-10",
  smc: "w-9 h-9 p-0.5",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  responsive: "w-12 h-12 sm:w-11 sm:h-11 md:w-12 md:h-12 lg:w-14 lg:h-14",
  card: "w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12",
};

const sizeDimensions: Record<string, { w: number; h: number }> = {
  xs: { w: 32, h: 32 },
  sm: { w: 40, h: 40 },
  smc: { w: 36, h: 36 },
  md: { w: 48, h: 48 },
  lg: { w: 64, h: 64 },
  responsive: { w: 56, h: 56 },
  card: { w: 48, h: 48 },
};

export default function AppLogo({ className = "", size = "md", style, linkTo = "/", priority = false }: AppLogoProps) {
  const navigate = useNavigate();
  const dims = sizeDimensions[size];

  const img = (
    <img
      src={logoImage}
      alt="CreaFinancia Logo"
      width={dims.w}
      height={dims.h}
      loading={priority ? "eager" : "lazy"}
      decoding={priority ? "sync" : "async"}
      fetchPriority={priority ? "high" : "auto"}
      className={`object-contain rounded-xl logo-brand-border flex-shrink-0 ${sizeClasses[size]} ${className}`}
      style={style}
    />
  );

  if (linkTo === false) return img;

  return (
    <button onClick={() => navigate(linkTo)} className="cursor-pointer focus:outline-none" aria-label="Ir al inicio">
      {img}
    </button>
  );
}
